module.exports = __webpack_public_path__ + "static/blog23-748bc68a0d17eb38d7a8be78e6588200.png";